import size from 'lodash/size';
import { helpers } from 'vuelidate/lib/validators';

export const phoneValidator = (value) =>
  value ? /^\+?\d+$/.test(value) : true;

export const maxLengthValidator = (charLength) =>
  helpers.withParams(
    { length: charLength },
    (value) => size(value) <= charLength
  );

export const maxLength60 = maxLengthValidator(60);

export const maxLength20 = maxLengthValidator(20);

export const maxLength600 = maxLengthValidator(600);
